import { RefOption } from "../../../services/agenda/types";
import { IRefOptionsService } from "../../../services/refOptions";
import { ICacheManager } from "./RefOptionsCacheManager";

export interface IRefOptionsContextService {
  fetchCodes(): Promise<string[]>;
  fetchOptionsByCode(code: string): Promise<RefOption[]>;
  getCachedOptions(code: string): RefOption[] | null;
  cacheOptions(code: string, options: RefOption[]): void;
  clearCache(): void;
  hasCachedOptions(code: string): boolean;
}

export class RefOptionsContextService implements IRefOptionsContextService {
  constructor(
    private refOptionsService: IRefOptionsService,
    private cacheManager: ICacheManager,
  ) {}

  async fetchCodes(): Promise<string[]> {
    return this.refOptionsService.getOptionCodes();
  }

  async fetchOptionsByCode(code: string): Promise<RefOption[]> {
    return this.refOptionsService.getOptionsByCode(code);
  }

  getCachedOptions(code: string): RefOption[] | null {
    return this.cacheManager.get(code);
  }

  cacheOptions(code: string, options: RefOption[]): void {
    this.cacheManager.set(code, options);
  }

  clearCache(): void {
    this.cacheManager.clear();
  }

  hasCachedOptions(code: string): boolean {
    return this.cacheManager.has(code);
  }
}
